import axios from "axios";
import { Environment } from "../../configs/Environment";

export default axios.create({
    baseURL: Environment.backendUrl(),
    headers: {
        "Content-type": "application/json"
    }
});